import { render, staticRenderFns } from "./historicalCard.vue?vue&type=template&id=0514dba2&scoped=true&"
import script from "./historicalCard.vue?vue&type=script&lang=js&"
export * from "./historicalCard.vue?vue&type=script&lang=js&"
import style0 from "./historicalCard.vue?vue&type=style&index=0&id=0514dba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0514dba2",
  null
  
)

export default component.exports